class subMenu {
  constructor() {
    jQuery(function ($) {
      $('.menu-item-has-children > a').on('click', function (e) {
        e.preventDefault()
        $(this).parent().toggleClass('active')
        $(this).next('.sub-menu').slideToggle()
      })
    })
  }
}

export default subMenu
